import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
// Mappings between badge's sizes and variants, and design tokens
export const sizeMap = {
    large: {
        fontSize: tokens.fontSizes.medium,
        iconSize: 'small',
        sizing: '22px',
        spacing: '10px',
    },
    medium: {
        fontSize: tokens.fontSizes.small,
        iconSize: 'xsmall',
        sizing: '18px',
        spacing: tokens.spacing.small,
    },
    small: {
        fontSize: tokens.fontSizes.xsmall,
        iconSize: 'tiny',
        sizing: '16px',
        spacing: '6px',
    },
};
const badgeBaseStaticStyle = css({
    alignItems: 'center',
    display: 'inline-flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.bold,
    justifyContent: 'center',
    letterSpacing: '0.5px',
    lineHeight: tokens.lineHeights.tight,
    padding: `0 ${tokens.spacing.xsmall}`,
    textTransform: 'uppercase',
});
const badgeStaticStyle = {
    pill: css({
        borderRadius: '20px',
        padding: `0 ${tokens.spacing.small}`,
    }),
    regular: css({
        borderRadius: tokens.borderRadius.medium,
    }),
    ribbon: css({
        borderRadius: `${tokens.borderRadius.medium} 0 0 ${tokens.borderRadius.medium}`,
        position: 'relative',
    }),
};
export function badgeStyle({ size, type, variant }) {
    const isTransparentGrey = variant === 'greyLight' || variant === 'transparentGrey';
    // Set the styles as the default base colors or the specified accent variant
    const variantStyle = variant === 'base'
        ? {
            main: theme.background.contrastInverse,
            textOnColor: theme.text.inverse,
        }
        : theme[isTransparentGrey ? 'transparentGrey' : variant];
    return [
        badgeBaseStaticStyle,
        badgeStaticStyle[type],
        css(Object.assign(Object.assign({ backgroundColor: isTransparentGrey
                ? variantStyle.subtler
                : variantStyle.main, color: isTransparentGrey
                ? variantStyle.subtler
                : variantStyle.main, fontSize: sizeMap[size].fontSize, height: type === 'pill'
                ? `calc(${sizeMap[size].sizing} + ${tokens.spacing.xsmall})`
                : sizeMap[size].sizing }, (type === 'ribbon' && {
            marginRight: sizeMap[size].spacing,
        })), { span: {
                color: variantStyle.textOnColor,
            } })),
    ];
}
export const wrapperStaticStyle = css({
    alignItems: 'center',
    color: 'inherit',
    display: 'inline-flex',
    gap: tokens.spacing.xsmall,
    maxWidth: '164px',
});
export const innerContentStaticStyle = css({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
export const ribbonStaticStyle = css({
    height: 'inherit',
    position: 'absolute',
});
export function ribbonStyle({ size }) {
    return [ribbonStaticStyle, css({ right: `-${sizeMap[size].spacing}` })];
}
